<template>
  <div class="vx-row">
    <div v-if="displayExport != false" class="vx-col lg:w-1/4 w-full">
      <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/configurations/users-list'}" class="text-inherit underline">
          <feather-icon icon="UsersIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Users</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/efacturalogin'}" class="text-inherit underline">
          <feather-icon icon="KeyIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">SPV Token</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/ai'}" class="text-inherit underline">
          <feather-icon icon="CpuIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">AI</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/network'}" class="text-inherit underline">
          <feather-icon icon="WifiIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Network</h4>
      </vx-card>
    </div>
    <div v-if="displayExport != false" class="vx-col lg:w-1/4 w-full">
      <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/product/product-list'}" class="text-inherit underline">
          <feather-icon icon="PackageIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Products</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/product/product-category-list'}" class="text-inherit underline">
          <feather-icon icon="GridIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Product Categories</h4>
      </vx-card>
    </div>
    <div v-if="displayExport != false" class="vx-col lg:w-1/4 w-full">
      <!-- Mails automatiques, mail check, liens du mail de devis, historique des
           envois : une seule page depuis le 2026-10-18 (ex-Mail History et
           Quote Email Links, qui redirigent). -->
      <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/notifications'}" class="text-inherit underline">
          <feather-icon icon="BellIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Notifications</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/dependency-sync'}" class="text-inherit underline">
          <feather-icon icon="RefreshCwIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Dependency Sync</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/fiscal-config'}" class="text-inherit underline">
          <feather-icon icon="PrinterIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Casa de Marcat Datecs</h4>
      </vx-card>
    </div>
    <div v-if="false" class="vx-col lg:w-1/4 w-full">
      <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/shopify-sync'}" class="text-inherit underline">
          <feather-icon icon="ShoppingBagIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Shopify Sync</h4>
      </vx-card>
      <vx-card v-if="displayExport != false" title class="mb-base text-center cursor-pointer" id="page-user-view">
        <router-link :to="{path:'/settings/shopify-config'}" class="text-inherit underline">
          <feather-icon icon="SettingsIcon" svgClasses="w-24 h-24 mx-auto mb-4 text-primary" />
        </router-link>
        <h4 class="mb-2">Shopify Config</h4>
      </vx-card>
    </div>
    <div v-if="displayExport != true" class="vx-col lg:w-1/4 w-full">
      <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">You don't have permission to change settings.
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      displayExport: false,
    };
  },
  computed: {},
  methods: {},
  beforeDestroy() {},
  created() {
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }

    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
